export const COUPON_STATUSES = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
};

export const DISCOUNT_TYPES = {
    PERCENT: 'percent',
    AMOUNT: 'amount',
    NONE: 'none',
};

const APPLICABLE_TYPES = [DISCOUNT_TYPES.PERCENT, DISCOUNT_TYPES.AMOUNT];

export function normalizeCouponResponse(res, basePrice) {
    const coupon_type = String(res?.type || '').toLowerCase();
    const eligible = APPLICABLE_TYPES.includes(coupon_type);

    let discount = { type: DISCOUNT_TYPES.NONE, amount: 0, percent: 0 };
    if (coupon_type === DISCOUNT_TYPES.PERCENT) {
        const percent = res?.percent || 0;
        // Round to 2 decimals to match backend ROUND_PRECISION - prevents FE/BE maxPointsForDeal mismatch with coupon+points
        const rawAmount = Number.isFinite(basePrice) ? (basePrice || 0) * (percent / 100) : 0;
        const amount = Math.round(rawAmount * 100) / 100;
        discount = { type: DISCOUNT_TYPES.PERCENT, percent, amount };
    } else if (coupon_type === DISCOUNT_TYPES.AMOUNT) {
        discount = { type: DISCOUNT_TYPES.AMOUNT, amount: res?.amount || 0, percent: 0 };
    }

    return { eligible, discount };
}

export const COUPON_ERROR_I18N_KEYS = {
    coupon_not_found: 'CouponErrorNotFound',
    coupon_expired: 'CouponErrorExpired',
    coupon_disabled: 'CouponErrorDisabled',
    coupon_usage_limit: 'CouponErrorUsageLimit',
    coupon_min_spend: 'CouponErrorMinSpend',
    coupon_not_eligible: 'CouponErrorNotEligible',
    coupon_wrong_company: 'CouponErrorWrongCompany',
    coupons_not_enabled: 'CouponErrorNotEnabled',
    coupon_invalid: 'CouponErrorInvalid',
};

export function resolveCouponErrorMessage(t, payload) {
    const errorCode = payload?.error_code;
    const i18nKey = COUPON_ERROR_I18N_KEYS[errorCode];
    if (i18nKey) {
        return t(i18nKey);
    }
    if (typeof payload?.user_message === 'string' && payload.user_message.length > 0) {
        return payload.user_message;
    }
    return t('CouponCodeErrorMessage');
}
